import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEyeOff = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m21.2 21.2-1.4 1.4-4.2-4.15q-.874.274-1.762.412A12 12 0 0 1 12 19q-3.775 0-6.725-2.088T1 11.5q.525-1.325 1.325-2.463A11.5 11.5 0 0 1 4.15 7L1.4 4.2l1.4-1.4zM12 4q3.775 0 6.725 2.088T23 11.5a11.7 11.7 0 0 1-1.513 2.737A11 11 0 0 1 19.3 16.45l-3.175-3.15q.176-.425.275-.863.1-.437.1-.937 0-1.876-1.312-3.187Q13.875 7 12 7q-.5 0-.937.1a4.2 4.2 0 0 0-.863.3L7.65 4.85a11 11 0 0 1 2.1-.637A11.6 11.6 0 0 1 12 4m-4.375 6.475q-.075.275-.1.512a5 5 0 0 0-.025.513q0 1.875 1.313 3.188Q10.125 16 12 16a5 5 0 0 0 .513-.025q.238-.025.512-.1zm4.05-1.625a2.3 2.3 0 0 1 1.288.113q.586.238 1.012.687.425.45.613 1.037.187.588.087 1.163z" })
});
export default SvgEyeOff;
